// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  legId: __t.u64().primaryKey().name("leg_id"),
  legKey: __t.string().name("leg_key"),
  runKey: __t.string().name("run_key"),
  tier: __t.string(),
  kind: __t.string(),
  x: __t.f64(),
  z: __t.f64(),
  spot: __t.string(),
  status: __t.string(),
  notes: __t.string(),
  samples: __t.u32(),
  fpsAvg: __t.f32().name("fps_avg"),
  fpsP05: __t.f32().name("fps_p_05"),
  frameMsP50: __t.f32().name("frame_ms_p_50"),
  frameMsP95: __t.f32().name("frame_ms_p_95"),
  frameMsP99: __t.f32().name("frame_ms_p_99"),
  frameMsMax: __t.f32().name("frame_ms_max"),
  drawCallsAvg: __t.u32().name("draw_calls_avg"),
  trianglesAvg: __t.u64().name("triangles_avg"),
  trianglesMax: __t.u64().name("triangles_max"),
  pipelines: __t.u32(),
  heapMbAvg: __t.f32().name("heap_mb_avg"),
  heapMbMax: __t.f32().name("heap_mb_max"),
  loafCount: __t.u32().name("loaf_count"),
  loafMsTotal: __t.f32().name("loaf_ms_total"),
  gpuMsAvg: __t.f32().name("gpu_ms_avg"),
  censusJson: __t.string().name("census_json"),
  extrasJson: __t.string().name("extras_json"),
  startedAt: __t.timestamp().name("started_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
